import { useQuery } from "@tanstack/react-query"
import fetchOrders from "api/fetchTransactions"
import ProfileLayout from "components/Layout/Profile/ProfileLayout"
import OrderTab from "components/page_components/User/Tabs/Order/OrderTab"
import { NextSeo } from "next-seo"
import { motion } from "framer-motion"
import ProfileSkeleton from "components/Skeleton/ProfileSkeleton"

const Orders = () => {
    const { data, isLoading, isSuccess } = useQuery({
        queryKey: ["orders"],
        queryFn: fetchOrders,
    })

    const ordersData = data?.payload
        ? [...data.payload].sort((a: any, b: any) => {
              const dateA = new Date(a.ordered_at).getTime()
              const dateB = new Date(b.ordered_at).getTime()
              return dateB - dateA
          })
        : []

        
    return (
        <>
            <NextSeo
                noindex
                nofollow
            />
            <ProfileLayout>
                {isLoading ? (
                    <ProfileSkeleton type="card" />
                ) : (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.25 }}>
                        <OrderTab
                            orders={ordersData}
                            isSuccess={isSuccess}
                        />
                    </motion.div>
                )}
            </ProfileLayout>
        </>
    )
}

export default Orders
